import React from 'react';
import { InstagramIcon, TwitterIcon, FacebookIcon } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-gradient-dark border-t border-red-900/20" data-id="element-72">
      <div className="container mx-auto px-4 py-12" data-id="element-73">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-74">
          <div className="md:col-span-1" data-id="element-75">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6bvXLLLbgQPyGsuTNy77Kh/Screenshot_2025-04-12_at_11.48.16_AM-removebg-preview.png" alt="Chicago Kush Logo" className="h-16 mb-4" data-id="element-76" />
            <p className="text-gray-400 mb-4" data-id="element-77">
              Premium cannabis products crafted with care.
            </p>
            <div className="flex space-x-4" data-id="element-78">
              <a href="#" className="text-gray-400 hover:text-red-500 transition" data-id="element-79">
                <InstagramIcon size={20} data-id="element-80" />
              </a>
              <a href="#" className="text-gray-400 hover:text-red-500 transition" data-id="element-81">
                <TwitterIcon size={20} data-id="element-82" />
              </a>
              <a href="#" className="text-gray-400 hover:text-red-500 transition" data-id="element-83">
                <FacebookIcon size={20} data-id="element-84" />
              </a>
            </div>
          </div>
          <div data-id="element-85">
            <h3 className="text-white font-bold mb-4" data-id="element-86">Quick Links</h3>
            <ul className="space-y-2" data-id="element-87">
              <li data-id="element-88">
                <a href="#" className="text-gray-400 hover:text-red-500 transition" data-id="element-89">
                  Home
                </a>
              </li>
              <li data-id="element-90">
                <a href="#products" className="text-gray-400 hover:text-red-500 transition" data-id="element-91">
                  Products
                </a>
              </li>
              <li data-id="element-92">
                <a href="#about" className="text-gray-400 hover:text-red-500 transition" data-id="element-93">
                  About
                </a>
              </li>
              <li data-id="element-94">
                <a href="#" className="text-gray-400 hover:text-red-500 transition" data-id="element-95">
                  Shop
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-96">
            <h3 className="text-white font-bold mb-4" data-id="element-97">Products</h3>
            <ul className="space-y-2" data-id="element-98">
              <li data-id="element-99">
                <a href="#" className="text-gray-400 hover:text-red-500 transition" data-id="element-100">
                  Flower
                </a>
              </li>
              <li data-id="element-101">
                <a href="#" className="text-gray-400 hover:text-red-500 transition" data-id="element-102">
                  Pre-Rolls
                </a>
              </li>
              <li data-id="element-103">
                <a href="#" className="text-gray-400 hover:text-red-500 transition" data-id="element-104">
                  Concentrates
                </a>
              </li>
              <li data-id="element-105">
                <a href="#" className="text-gray-400 hover:text-red-500 transition" data-id="element-106">
                  Edibles
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-107">
            <h3 className="text-white font-bold mb-4" data-id="element-108">Contact</h3>
            <ul className="space-y-2" data-id="element-109">
              <li data-id="element-110">
                <a href="mailto:info@chicagokush.com" className="text-gray-400 hover:text-red-500 transition" data-id="element-111">
                  info@chicagokush.com
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-center" data-id="element-112">
          <p className="text-gray-500 text-sm" data-id="element-113">
            © {new Date().getFullYear()} Chicago Kush. All rights reserved.
          </p>
          <p className="text-gray-600 text-xs mt-2" data-id="element-114">
            For adults 21 and older. Please consume responsibly. Cannabis
            products may be purchased or possessed only by persons 21 years of
            age or older.
          </p>
        </div>
      </div>
    </footer>;
};